module.exports = __webpack_public_path__ + "img/avatar.ca440244.png";